export const BEST_RANKED_PODCASTS_DISPLAY_AMOUNT = 4;
